/* tslint:disable */
/* eslint-disable */
/**
 * Web MMB BFF API
 * Version of Backend for Frontend API (mid-layer between FE and MMB API) designed for web frontend purposes.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AlternativeItineraryBannerActionFromJSON, AlternativeItineraryBannerActionToJSON, } from './AlternativeItineraryBannerAction';
/**
 * @export
 */
export const AlternativeItineraryBannerIconEnum = {
    Accommodation: 'accommodation',
    Alert: 'alert',
    Baggage: 'baggage',
    Check: 'check',
    Clock: 'clock',
    Diamond: 'diamond',
    Guarantee: 'guarantee',
    Info: 'info',
    Moon: 'moon',
    NoBaggage: 'no_baggage',
    SelfTransfer: 'self_transfer',
    Star: 'star',
    Visa: 'visa'
};
/**
 * @export
 */
export const AlternativeItineraryBannerTypeEnum = {
    Info: 'info',
    Success: 'success',
    Warning: 'warning',
    Critical: 'critical'
};
/**
 * Check if a given object implements the AlternativeItineraryBanner interface.
 */
export function instanceOfAlternativeItineraryBanner(value) {
    if (!('description' in value) || value['description'] === undefined)
        return false;
    if (!('icon' in value) || value['icon'] === undefined)
        return false;
    if (!('title' in value) || value['title'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
export function AlternativeItineraryBannerFromJSON(json) {
    return AlternativeItineraryBannerFromJSONTyped(json, false);
}
export function AlternativeItineraryBannerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'action': json['action'] == null ? undefined : AlternativeItineraryBannerActionFromJSON(json['action']),
        'description': json['description'],
        'icon': json['icon'],
        'title': json['title'],
        'type': json['type'],
    };
}
export function AlternativeItineraryBannerToJSON(json) {
    return AlternativeItineraryBannerToJSONTyped(json, false);
}
export function AlternativeItineraryBannerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'action': AlternativeItineraryBannerActionToJSON(value['action']),
        'description': value['description'],
        'icon': value['icon'],
        'title': value['title'],
        'type': value['type'],
    };
}
